
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    image: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      projectVersion: process.env.VUE_APP_VERSION,
    };
  },
});
